import { SelectProps } from '@material-ui/core/Select';
import UnfoldMoreOutlined from '@material-ui/icons/UnfoldMoreOutlined';

const MuiSelect: SelectProps = {
    IconComponent: UnfoldMoreOutlined,
    variant: 'outlined',
    MenuProps: { PaperProps: { elevation: 0, variant: 'outlined' } },
};

export default MuiSelect;
